import type { DrawingDateRange } from '../types';

type ExpandDrawingDateRangesOptions = {
  descending?: boolean;
};

/**
 * Expands compressed inclusive integer ranges into a sorted, de-duplicated list of values.
 * e.g. `[{ from: 1, to: 3 }, { from: 5, to: 7 }]` → `[1, 2, 3, 5, 6, 7]`
 * Pass `{ descending: true }` to get the values newest-first, e.g. `[7, 6, 5, 3, 2, 1]`.
 */
function expandDrawingDateRanges(ranges: DrawingDateRange[] | undefined, options: ExpandDrawingDateRangesOptions = {}): number[] {
  const { descending = false } = options;
  if (!ranges?.length) return [];

  const values = new Set<number>();
  for (const range of ranges) {
    if (range.from > range.to) continue;
    for (let value = range.from; value <= range.to; value += 1) {
      values.add(value);
    }
  }

  return [...values].sort((aa, bb) => (descending ? bb - aa : aa - bb));
}

export { expandDrawingDateRanges };
export type { ExpandDrawingDateRangesOptions };
